import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../config/api";
import { useAuth } from "../../components/AuthProvider";
import { useI18n } from "../../i18n";
import { GovernanceListingSection } from "../../components/governance/GovernanceListingSection";
import { ComplianceCenterMetricTile } from "../../components/compliance-center/ComplianceCenterMetricTile";
import listStyles from "@/styles/pages/governance/GovernanceListing.module.scss";

export default function ComplianceCenterGrcAdminWorkspace() {
  const { t } = useI18n();
  const { token } = useAuth();
  const [counts, setCounts] = useState({ hierarchy: 0, businessUnits: 0, sharedControls: 0, sso: 0, rbac: 0, integrations: 0 });

  useEffect(() => {
    const load = async () => {
      const headers = { Authorization: `Bearer ${token}` };
      const [hierarchyRes, businessUnitsRes, sharedControlsRes, ssoRes, rbacRes, integrationsRes] = await Promise.all([
        fetch(API_ENDPOINTS.GRC_ORG_HIERARCHY, { headers }),
        fetch(API_ENDPOINTS.GRC_BUSINESS_UNITS, { headers }),
        fetch(API_ENDPOINTS.GRC_SHARED_CONTROLS, { headers }),
        fetch(API_ENDPOINTS.IDENTITY_SSO, { headers }),
        fetch(API_ENDPOINTS.IDENTITY_RBAC_POLICIES, { headers }),
        fetch(API_ENDPOINTS.IDENTITY_ENTERPRISE_INTEGRATIONS, { headers }),
      ]);
      const asArray = async (res: Response) => (res.ok ? (await res.json().catch(() => ({})))?.data || [] : []);
      setCounts({
        hierarchy: (await asArray(hierarchyRes)).length,
        businessUnits: (await asArray(businessUnitsRes)).length,
        sharedControls: (await asArray(sharedControlsRes)).length,
        sso: (await asArray(ssoRes)).length,
        rbac: (await asArray(rbacRes)).length,
        integrations: (await asArray(integrationsRes)).length,
      });
    };
    void load();
  }, [token]);

  return (
    <div className={listStyles.pageStack}>
      <GovernanceListingSection
        title={t("complianceCenterUi.nav.grcAdmin", "GRC Admin")}
        description={t(
          "complianceCenterUi.grcAdminIntro",
          "Org hierarchy, business units, shared controls, SSO, RBAC, and enterprise integrations.",
        )}
      >
        <div className={`${listStyles.metricsGrid} ${listStyles.metricsGrid6}`}>
          <ComplianceCenterMetricTile label={t("complianceCenterUi.hierarchyLinks", "Hierarchy links")} value={counts.hierarchy} tone="blue" />
          <ComplianceCenterMetricTile label={t("complianceCenterUi.businessUnits", "Business units")} value={counts.businessUnits} tone="green" />
          <ComplianceCenterMetricTile label={t("complianceCenterUi.sharedControls", "Shared controls")} value={counts.sharedControls} tone="purple" />
          <ComplianceCenterMetricTile label={t("complianceCenterUi.ssoConfigs", "SSO configs")} value={counts.sso} tone="orange" />
          <ComplianceCenterMetricTile label={t("complianceCenterUi.rbacPolicies", "RBAC policies")} value={counts.rbac} tone="yellow" />
          <ComplianceCenterMetricTile
            label={t("complianceCenterUi.enterpriseIntegrations", "Enterprise integrations")}
            value={counts.integrations}
            tone="red"
          />
        </div>
      </GovernanceListingSection>
    </div>
  );
}
